import { connect } from 'react-redux';
import { AppState } from 'src/ducks';
import { getOverlays } from 'src/ducks/ui/overlay';

import OverlayController from './OverlayController';

const mapStateToProps = (state: AppState) => ({ overlays: getOverlays(state) });

export default connect(mapStateToProps)(OverlayController);
